import { Typography, TypographyProps } from '@mui/material';
import { combineSX } from '@/utils/combineSX';
import { DpScrollSubtitleSX } from '@/components/blocks/DpLibrary/DpScrollSubtitle/style/style';

export const DpScrollSubtitle = ({ children, component, sx, ...props }: TypographyProps) => (
	<Typography
		component={component || 'h2'}
		sx={combineSX([DpScrollSubtitleSX, ...(Array.isArray(sx) ? sx : [sx])])}
		{...props}
	>
		{children}
	</Typography>
);
